// Butterstone River Valley — content constants (placeholders; owner replaces media later)

export const BRAND = {
  name: 'Butterstone River Valley',
  shortName: 'Butterstone',
  group: 'Fernest Group of Resorts',
  tagline: 'Riverside · Coffee Estate · Western Ghats',
  location: 'Sakleshpur, Western Ghats, Karnataka',
};

export const CONTACT = {
  phone1: '7338620111',
  phone2: '6366261112',
  phone1Display: '+91 73386 20111',
  phone2Display: '+91 63662 61112',
  email: 'butterstonerivervalleyresort@gmail.com',
  whatsapp: '917338620111',
  instagram: 'https://www.instagram.com/butterstone.sakleshpur/',
  instagramHandle: '@butterstone.sakleshpur',
};

// Videos — self-hosted placeholders in /public/media (replace with owner footage)
export const VIDEOS = {
  hero: '/media/hero.mp4',
  activity1: '/media/act1.mp4',
  activity2: '/media/act2.mp4',
  activity3: '/media/act1.mp4',
};

const U = (id, w = 1400) => `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=82&w=${w}`;

export const IMG = {
  riverAerial: U('1660269040593-63eb316ac8d2'),
  forestAerial: U('1709193628685-3b90be2d53f2'),
  streamForest: U('1717325229625-fba1da0d4a54'),
  greenWater: U('1585143350430-f475f33cba2d'),
  treeWater: U('1656555606325-96de00786534'),
  coffeeAerial: U('1458360112982-28942a1f776e'),
  greenSlope: U('1559038300-07cb5d6c3d27'),
  valley: 'https://images.pexels.com/photos/3848200/pexels-photo-3848200.jpeg?auto=compress&cs=tinysrgb&w=1400',
  waterfall: U('1542157565-4607d82cf417'),
  mossWaterfall: U('1582137363701-90dfd38fe801'),
  mistyField: U('1589428983150-c8c675fc2476'),
  greenMountain: U('1627609243025-22613935dfa1'),
  pool: U('1699413935716-aa75fb58ec1a'),
  zip1: U('1648853070657-6d58398bee93'),
  zip2: U('1712782516688-cbcbf93b1b7c'),
  tent1: U('1657664069074-8b245ee46be9'),
  tent2: 'https://images.pexels.com/photos/33117408/pexels-photo-33117408.jpeg?auto=compress&cs=tinysrgb&w=1400',
  room1: U('1689729771136-46e2ee831b83'),
  room2: U('1665930152500-26acb7c86076'),
  volley1: U('1592656094267-764a45160876'),
  volley2: U('1612872087720-bb876e2e67d1'),
  basket: U('1600534220378-df36338afc40'),
  tramp: U('1642932163549-3af44da6017f'),
  dorm: U('1709805619372-40de3f158e83'),
};

export const GALLERY = [
  { src: IMG.riverAerial, label: 'The River Through the Estate', span: 'lg:col-span-2 lg:row-span-2' },
  { src: IMG.coffeeAerial, label: 'Coffee Estate', span: '' },
  { src: IMG.waterfall, label: 'Magajahalli Abbi Falls', span: '' },
  { src: IMG.mistyField, label: 'Valley Viewpoint', span: 'lg:col-span-2' },
  { src: IMG.streamForest, label: 'Riverside Trails', span: '' },
  { src: IMG.greenMountain, label: 'Western Ghats', span: '' },
  { src: IMG.pool, label: 'Scenic Outdoor Pool', span: '' },
  { src: IMG.tent1, label: 'Riverside Camping', span: 'lg:col-span-2' },
];

// Activities — first item is the featured video tile in the bento
export const ACTIVITIES = [
  { title: 'Outdoor Scenic Pool', desc: 'An open-air swimming pool framed by the estate and the Ghats.', img: IMG.pool },
  { title: '100m River Zipline', desc: 'Soar 100 metres across the river on our signature zipline.', img: IMG.zip1 },
  { title: 'Rope Activities', desc: 'Burma bridges, rope courses and thrilling aerial obstacles.', img: IMG.zip2 },
  { title: 'Rain Dance', desc: 'Dance it out under the showers with music and lights.', img: IMG.mossWaterfall },
  { title: 'Mud Volleyball', desc: 'Get gloriously messy in our riverside mud volleyball pit.', img: IMG.volley1 },
  { title: 'Basketball', desc: 'Shoot hoops on our open-air court amid the greenery.', img: IMG.basket },
  { title: 'Badminton', desc: 'Rally with friends on the badminton court.', img: IMG.volley2 },
  { title: 'Trampoline', desc: 'Bounce with joy — a favourite for kids and the young at heart.', img: IMG.tramp },
  { title: 'Indoor Games', desc: 'Carrom, table tennis, board games and more for lazy afternoons.', img: IMG.room2 },
  { title: 'Riverside Experience', desc: 'Wade, relax and picnic beside the river flowing through the property.', img: IMG.treeWater },
];

// Guest review videos — owner will paste YouTube IDs later
export const REVIEWS = [
  { name: 'Guest Review', place: 'Bengaluru', youtubeId: '', poster: IMG.streamForest },
  { name: 'Guest Review', place: 'Mysuru', youtubeId: '', poster: IMG.pool },
  { name: 'Guest Review', place: 'Mangaluru', youtubeId: '', poster: IMG.tent1 },
  { name: 'Guest Review', place: 'Corporate Offsite', youtubeId: '', poster: IMG.zip1 },
];

// Social marquee posts/reels (placeholders → open Instagram profile)
export const SOCIAL = [
  { img: IMG.riverAerial, type: 'reel' },
  { img: IMG.coffeeAerial, type: 'post' },
  { img: IMG.pool, type: 'reel' },
  { img: IMG.waterfall, type: 'post' },
  { img: IMG.tent1, type: 'reel' },
  { img: IMG.mistyField, type: 'post' },
  { img: IMG.zip1, type: 'reel' },
  { img: IMG.greenWater, type: 'post' },
];

export const NEARBY = [
  { name: 'Magajahalli Abbi Falls', type: 'Waterfall', note: 'Just 300 m from the property', img: IMG.waterfall },
  { name: 'Manjehalli Falls', type: 'Waterfall', img: IMG.mossWaterfall },
  { name: 'Mookanamane Falls', type: 'Waterfall', img: IMG.streamForest },
  { name: 'Bisle Ghat View Point', type: 'Viewpoint', img: IMG.mistyField },
  { name: 'Kaginahare View Point', type: 'Viewpoint', img: IMG.greenMountain },
  { name: 'Jenukal Gudda', type: 'Trekking / Peak', img: IMG.greenSlope },
  { name: 'Patla Betta', type: 'Trekking / Viewpoint', img: IMG.forestAerial },
  { name: 'Ombattu Gudda', type: 'Trekking', img: IMG.valley },
  { name: 'Hosahalli Gudda', type: 'Hill / Viewpoint', img: IMG.greenMountain },
  { name: 'Manjarabad Fort', type: 'Historical', img: IMG.mistyField },
  { name: 'Bettada Byraveshwara Temple', type: 'Temple / Viewpoint', img: IMG.greenSlope },
  { name: 'Sakleshwar Temple', type: 'Temple', img: IMG.forestAerial },
  { name: 'Agrahara Belaguli', type: 'Temple / Heritage', img: IMG.valley },
  { name: 'Hemavathi Reservoir', type: 'Scenic Spot', img: IMG.riverAerial },
  { name: 'Bisle Reserve Forest', type: 'Forest / Nature', img: IMG.streamForest },
  { name: 'Kukke Subramanya', type: 'Temple / Day Trip', img: IMG.greenWater },
  { name: 'Ettina Bhuja', type: 'Trekking / Viewpoint', img: IMG.greenMountain },
  { name: 'Kumara Parvatha', type: 'Trekking', img: IMG.greenSlope },
  { name: 'Pandavar Gudda', type: 'Hill / Viewpoint', img: IMG.forestAerial },
  { name: 'Dodda Betta', type: 'Hill / Viewpoint', img: IMG.mistyField },
];

export const CORPORATE = {
  perks: [
    'Team-building rope & zipline circuits',
    'Riverside bonfire & BBQ evenings',
    'Conference-ready open lawns & indoor spaces',
    'Group dormitories for up to 26 guests',
    'Curated adventure & wellness itineraries',
    'All-inclusive food & activity packages',
  ],
};
